<div
  class="editor-wrapper"
  [ngStyle]="{ top: top + 'px', left: left + 'px' }"
  cdkDrag
>
  <div class="toolbar" cdkDragHandle>
    <i class="pi pi-check cursor-pointer" *ngIf="isCurrentUser" (click)="onSave()"></i>
    <i class="pi pi-times cursor-pointer" (click)="onDelete()"></i>
  </div>
  <p-editor [(ngModel)]="text" [disabled]="isCurrentUser"></p-editor>
  <div class="footer" cdkDragHandle></div>
</div>
